import type { Flags } from '@reflag/react-sdk';

/** App-only rollout flag for audit-log visibility. */
export const AUDIT_LOGS_FEATURE_FLAG = 'AUDIT_LOGS' as FeatureFlagKey;

/** App-only rollout flag for the style guide checks tab. */
export const STYLEGUIDE_CHECKS_FEATURE_FLAG = 'STYLEGUIDE_CHECKS' as FeatureFlagKey;

/**
 * Key for all feature flags.
 */
export type FeatureFlagKey = keyof Flags;

/**
 * All feature flags, managed by bucket.co.
 */
export type EnabledFeatureFlagsMap = { [key in FeatureFlagKey]: boolean };
